import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { getSettings } from '../services/getSettings';

export const loadSettings = createAsyncThunk(
  'expenseTracking/loadSettings',
  async (params, { getState, dispatch }) => {
    const state = getState();

    const selectedProjectId = selectSelectedProjectId(state);

    const response = await getSettings(selectedProjectId);

    return response;
  }
);
